const ITEMS = [
  "Metodyka",
  "Sztuczna inteligencja",
  "Gry na speaking",
  "Prompty",
  "50 pomysłów na speaking",
  "Gry do druku",
  "Gry interaktywne",
];

export const Marquee = () => {
  const row = (ariaHidden) => (
    <div aria-hidden={ariaHidden} className="flex shrink-0 items-center">
      {ITEMS.map((item) => (
        <span key={item + (ariaHidden ? "-b" : "-a")} className="flex items-center">
          <span className="font-display px-6 text-lg uppercase tracking-wide text-white sm:text-xl">
            {item}
          </span>
          <span className="h-2.5 w-2.5 rotate-45 border border-ink bg-cyan" aria-hidden="true" />
        </span>
      ))}
    </div>
  );
  return (
    <div
      data-testid="editorial-marquee"
      className="overflow-hidden border-y-4 border-ink bg-magenta py-3.5"
    >
      <div className="marquee-track flex w-max">
        {row(false)}
        {row(true)}
      </div>
    </div>
  );
};
